import { SelectItem } from 'primeng/api';
import { HttpClient, HttpEventType, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild,Input} from '@angular/core';
import { FileUploadService } from './file-upload.service';
import { Observable } from 'rxjs';
import { LoaderService } from '../common/loader.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as CommonConstants from '../utils/common.constants';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MasterService } from '../masters/master.service';
import { FileUpload } from 'primeng/primeng';
import { SharedService } from 'src/app/utils/shared.service';
import swal from 'sweetalert2';

@Component({
  selector: 'file-upload',
  templateUrl: './file-upload.component.html'
})

export class FileUploadComponent implements OnInit {

  selectedFiles: FileList;
  currentFile: File;
  progress = 0;
  message = '';
  masterCodes;
  fileInfos: Observable<any>;
  uploadForm: FormGroup;
  PARAM_CODE_KEY = [CommonConstants.DOCUMENT_TYPE];
  uploadedFiles = [];
  attachments = [];
  files = [];
  medfiId;
  docTypes = [];
  medicalDocuments = [];
  @Input() patieId;
  PARAM__CODE_KEY = [CommonConstants.DOCUMENT_TYPE];
  fileStatus: string;
  //@ViewChild('fileInput' ,{static : false}) fileInput: FileUpload; 
  constructor(private modalService: NgbModal, private formBuilder: FormBuilder, private masterService: MasterService,
    private uploadService: FileUploadService, private sharedService: SharedService, private loaderService: LoaderService) { }

  ngOnInit() {
    this.fileStatus=localStorage.getItem(CommonConstants.FILE_STATUS);
    this.loadMasters();
    this.sharedService.medicalFileId$.subscribe(res => {
      this.medfiId = res;
      this.fetchMedicalFileDocuments();
    })




    //  this.fileInfos = this.uploadService.getFiles();
    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });
  }

  fetchMedicalFileDocuments() {
    this.uploadService.getMedicalDocuments('F', this.medfiId).subscribe(res => {
      if (res && res["result"]) {
        this.medicalDocuments = res["result"].map(item => ({
          ...item,
          fileName: this.fetchFileName(item.meddoVaPath),
          // docType :   item.dotypId ? this.docTypes.find(obj => obj.dotypId === item.dotypId).dotypDescriptionEn : null
        }));
      }

    })
  }
  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadForm.get('profile').setValue(file);
    }
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
    /*    if (event.target.files.length > 0) {
         const file = event.target.files[0];
         this.uploadForm.get('profile').setValue(file);
       } */
  }
  addDocModal(addDoc) {
    this.attachments = [];
    this.modalService.open(addDoc, { size: 'xl', container: '.page-content' });
  }
  /*   upload() {
      this.progress = 0;
  
      this.currentFile = this.selectedFiles.item(0);
      const formData = new FormData();
  
      formData.append('file', this.selectedFiles.item(0));
      formData.append("name", "roshen");
      this.uploadService.upload(formData).subscribe(
        event => {
          if (event.type === HttpEventType.UploadProgress) {
  
            this.progress = Math.round(100 * event.loaded / event.total);
          } else if (event instanceof HttpResponse) {
            this.message = event.body.message;
            //     this.fileInfos = this.uploadService.getFiles();
          }
        },
        err => {
          this.progress = 0;
          this.message = 'Could not upload the file!';
          this.currentFile = undefined;
        });
  
      this.selectedFiles = undefined;
    } */
  loadMasters() {
    this.masterService.getDocTypes().subscribe(res => {
      if (res && res["result"]) {
        this.docTypes = res["result"];
      }
    })
    this.masterService.getMastersCodesByParamKey(this.PARAM__CODE_KEY).subscribe(response => {
      if (response && response['result']) {
        this.masterCodes = response['result'];
        this.docTypes = this.masterCodes.filter(master => master.paramKey === CommonConstants.DOCUMENT_TYPE);
      }
    });
  }

  onUpload(event) {
    const formData = new FormData();
    for (let file of event.files) {
      formData.append("file", file);
    }
    this.loaderService.display(true);
    this.uploadService.upload(formData).subscribe(
      event => {
        this.loaderService.display(false);
        if (event && event["result"]) {
          this.attachments.unshift(...event["result"]);
          this.attachments = this.attachments.map(item => ({
            'meddoVaPath': item,
            'medfiId': this.medfiId,
            'patieId':this.patieId
          }))
        }
       else {
        if (event instanceof HttpResponse) {
          if (event && event.body.result) {
            let result = event.body.result.map(item => ({
              'meddoVaPath': item,
              'medfiId': this.medfiId,
              'patieId':this.patieId
            }));
            this.attachments.unshift(...result);
          }
        }
        
        }
      },
      error => {
        this.loaderService.display(false);
      });
  }

  saveAttachment() {
    this.attachments["meddoDtIssue"]=this.attachments["meddoDtIssue"] ? this.sharedService.getDateFormat(this.attachments["meddoDtIssue"]) : null;
    for(let item of this.attachments){
      item.meddoDtIssue=item.meddoDtIssue ? this.sharedService.getDateFormat(item.meddoDtIssue) : null;
    }
    this.uploadService.saveAttachment(this.attachments).subscribe(res => {
      if (res && res["result"]) {
        this.modalService.dismissAll();
        this.fetchMedicalFileDocuments();
        swal.fire('Success',"Document Uploaded Successfully",'success');
      }
    })
  }

  fetchFileName(str) {
    str = str.substr(str.lastIndexOf("$") + 1);
    return str;
  }

  downloadFile(path: string) {
    //Check the file format(working on more generic way)
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.download = this.fetchFileName(path);
    a.href = "/" + CommonConstants.FILES_CONTEXT +"/" + path;
    a.click();
  }

  onRowClicked(event) {
    if (event.data) {
      this.downloadFile(event.data.meddoVaPath);
    }
  }
  removeFile(file) {

  }
  /*  onSubmit() {
     const formData = new FormData();
     formData.append('file', this.uploadForm.get('profile').value);
     
     this.http.post<any>(CommonConstants.env+"api/master/upload", formData).subscribe(
       (res) => console.log(res),
       (err) => console.log(err)
     );
   } */
}


